import { useQuery } from '@tanstack/react-query';
import {
    MemberId,
    MissionId,
    AntennaId,
    FormationId,
    AnimationId,
    globalSearch,
    SearchResult,
    SupplyId,
} from '@wwf/sdk';
import { getLinkToAntenna } from '@app/antenna/getLinkToAntenna';
import { getLinkToMember } from '@app/member/getLinkToMember';
import { getLinkToMission } from '@app/mission/getLinkToMission';
import { getLinkToFormation } from '@app/formation/getLinkToFormation';
import { getLinkToAnimation } from '@app/animation/getLinkToAnimation';
import { getLinkToSupply } from '@app/supply/getLinkToSupply';

export interface SearchResultWithUrl extends SearchResult {
    url: string;
}

function rowToSearchResult(row: SearchResult): SearchResultWithUrl {
    let url: string;
    switch (row.resultType) {
        case 'member':
            url = getLinkToMember(row.id as MemberId);
            break;
        case 'mission':
            url = getLinkToMission(row.id as MissionId);
            break;
        case 'antenna':
            url = getLinkToAntenna(row.id as AntennaId);
            break;
        case 'formation':
            url = getLinkToFormation(row.id as FormationId);
            break;
        case 'animation':
            url = getLinkToAnimation(row.id as AnimationId);
            break;
        case 'supply':
            url = getLinkToSupply(row.id as SupplyId);
            break;
        default:
            row.resultType satisfies never;
            url = '';
    }
    return { ...row, url };
}

export const useGlobalSearch = (query: string, limit: number = 50) => {
    const searchQuery = query.trim();

    const { data, isLoading } = useQuery<SearchResult[]>({
        queryKey: ['globalSearch', searchQuery, limit],
        queryFn: () => globalSearch(searchQuery, limit),
        enabled: searchQuery.length > 0,
    });

    const results =
        searchQuery.length > 0 ? (data?.map(rowToSearchResult) ?? []) : [];

    return {
        results,
        isLoading,
        hasResults: results.length > 0,
    };
};
